/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Player_LeadingInputs */

const en_mobile_player_leading = /** @type {(inputs: Mobile_Player_LeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spacing`)
};

const es_mobile_player_leading = /** @type {(inputs: Mobile_Player_LeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interlineado`)
};

/**
* | output |
* | --- |
* | "Spacing" |
*
* @param {Mobile_Player_LeadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_player_leading = /** @type {((inputs?: Mobile_Player_LeadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Player_LeadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_player_leading(inputs)
	return en_mobile_player_leading(inputs)
});